

import React,{useEffect,useState} from 'react';
import Axios from "/plugins/axios";
import ReactJWPlayer from 'react-jw-player';
import Head from 'next/head';
import TagManager from 'react-gtm-module';
import { Router } from '/routes';
import { isMobile } from "react-device-detect";
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {
    onReady,
    onUnmute,
    doUnMute,
    onPlay,
    onAutoStart,
    onThreeSeconds,
    onTenSeconds,
    onThirtySeconds,
    onTwentyFivePercent,
    onFiftyPercent,
    onSeventyFivePercent,
    onNinetyFivePercent,
    onOneHundredPercent,
    onVideoLoad
} from '/components/PlayerEventTracking/EventsJwplayer';

const localStyles = theme => ({
    overlay: {
        display: 'block',
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.3)',
        zIndex: -1
      },
    btnLabel: isMobile ? {
        display: 'flex',
        backgroundColor: '#fff',
        maxWidth: '142px',
        borderRadius: '4px',
        padding: '4px 0',
        position: 'absolute',
        top: '16px',
        left: '16px',
    } : {
        display: 'flex',
    },
    btnRoot: isMobile ? {
        position:'absolute',
        color: '#000',
        zIndex:999,

        top: '0',
        left: '0',
        backgroundColor: 'rgba(0,0,0,0.1)',
        width: '100%',
        height: '100%',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    } : {
        position:'absolute',
        top:'40px',
        left: '14px',
        color: '#000',
        backgroundColor:'#fff',
        zIndex:999,
    },
})

 const WidgetJwPlaylistPlayer = (props) => {
     const { isVideoWidget, customProps, data , source, poster, upNext, slickGoToProp, playlistPos, currentItem, classes, routeName, routeParams,
    isSectionVideoPlaylist, jwPlayerId } = props;
     const tvTypeIndex = currentItem.categories && currentItem.categories.findIndex((category) => category.type === 'TV')
     const type = tvTypeIndex >= 0 ? 'tv' : 'videos'; // if type is not TV, go to videoDetail.
     let pagePath = isSectionVideoPlaylist || isVideoWidget ? `/${type}/${currentItem.slug}`
     : `/${type}/${currentItem.slug}?list=${data.playlist_id}`; // // for playlist and latest videos
    const [playEvent, setPlayEvent] = useState(false);
    const isWidget = true;

    function onPlayWithState() {
        onPlay(currentItem, pagePath);
        setPlayEvent(true);
    }

    // function onVideoEnds(upNext, data, playlistPos, slickGoToProp, routeName, routeParams) {
    function onVideoEnds(event) {
        onOneHundredPercent(currentItem, pagePath);
        if(upNext){
            Router.pushRoute(routeName, routeParams)
            slickGoToProp.slickGoTo(playlistPos)
        }
    }
    function onPause(event){
        setPlayEvent(false)
    }
    function onResume(event){
        setPlayEvent(true)
    }
        return (
            <React.Fragment>
                <Head>
                    <link rel="stylesheet" href="/static/css/widgetStyle.css" />
                </Head>
                <div style={{ position: 'relative' }}>
                    {!playEvent ?
                        <a href={pagePath} target="_blank" className="shadow">
                            <span className="videoWidgetTitle">{currentItem.title}</span>
                        </a>
                        : null
                    }
                      <Button
                        classes={{root: classes.btnRoot, label: classes.btnLabel}}
                        variant="contained"
                        id="unmute-button"
                        style={{ display: window.PlayerUnMuted ? 'none': window.IsAutoPlaySupported ? 'inline' : 'none'}}
                        onClick={(e)=> doUnMute(jwPlayerId,e)}
                        >
                        <Icon>volume_off</Icon>
                        <Typography component="span" style={{ fontFamily: 'DuwunFont', paddingLeft: 5, lineHeight: '23px' }}>အသံဖွင့်ရန်နှိပ်ပါ</Typography>
                        </Button>
                        <div id="player-overlay" className={classes.overlay}>
                        {/* <style jsx>{scssStyles}</style> */}
                        </div>
                    <ReactJWPlayer
                        playerId={`${jwPlayerId}`}
                        playerScript={`https://cdn.jwplayer.com/libraries/${jwPlayerId}.js`}
                        playlist={[{
                            file: `${source}`,
                            image: `${poster}`,
                        },
                        ]}
                        isMuted={!window.PlayerUnMuted}
                        onAutoStart={() => onAutoStart(currentItem, pagePath)}
                        onVideoLoad={() => onVideoLoad(currentItem, pagePath, isWidget)} // correct
                        onThreeSeconds={() => onThreeSeconds(currentItem, pagePath)}
                        onTenSeconds={() => onTenSeconds(currentItem, pagePath)}
                        onThirtySeconds={() => onThirtySeconds(currentItem, pagePath)}
                        onTwentyFivePercent={() => onTwentyFivePercent(currentItem, pagePath)}
                        onFiftyPercent={() => onFiftyPercent(currentItem, pagePath)}
                        onSeventyFivePercent={() => onSeventyFivePercent(currentItem, pagePath)}
                        onNinetyFivePercent={() => onNinetyFivePercent(currentItem, pagePath)}
                        // onOneHundredPercent={e => onVideoEnds(upNext, data, playlistPos, slickGoToProp, routeName, routeParams)}
                        onOneHundredPercent={onVideoEnds}
                        onPlay={onPlayWithState}
                        onPause={onPause}
                        onResume={onResume}
                        onUnmute={onUnmute}
                        onReady={onReady}
                        isAutoPlay
                        width='100%'
                        height='100%'
                        customProps={customProps}
                        // customProps={
                        //     { // object containing properties to be applied directly to the JW Player instance
                        //         // ga: {
                        //         //     label: currentItem && currentItem.title || 'No Title'
                        //         // },
                        //         ... !currentItem.no_ads && currentItem.ad_tag && {
                        //             advertising : { // set custom AdTag
                        //                 client: "googima",
                        //                 tag: currentItem.ad_tag
                        //             }
                        //         },
                        //         ... currentItem.no_ads && { advertising : {tag: ''} } // inject empty AdTag
                        //     }
                        // }
                    />
               </div>
               </React.Fragment>
        );
};
export default withStyles(localStyles)(WidgetJwPlaylistPlayer);
